import { ipsos, supuesto } from ".";

// Lámina 108 (Perfumes). Pregunta 1 base 400; preguntas 2-5 base 365 (usuarios de perfume).
const P_USA = "¿Utiliza perfumes de forma habitual?";
const P_MARCA = "¿Qué marcas de perfume prefiere?";
const P_PRIORIDAD = "¿Qué prioriza más cuando compra un perfume?";
const P_FRECUENCIA = "¿Cada cuánto o en qué fecha suele comprar perfume?";
const P_CANTIDAD = "¿Cuántos perfumes suele utilizar?";

export const IPSOS_PERFUMES = {
  penetracion: ipsos(0.906, { lamina: 108, pregunta: P_USA, base: 400 }),
  noPenetracion: ipsos(0.094, { lamina: 108, pregunta: P_USA, base: 400 }),
  marcas: {
    Rabanne: ipsos(0.095, { lamina: 108, pregunta: P_MARCA, base: 365 }),
    "Carolina Herrera": ipsos(0.083, { lamina: 108, pregunta: P_MARCA, base: 365 }),
    "Victoria Secret": ipsos(0.073, { lamina: 108, pregunta: P_MARCA, base: 365 }),
    Versace: ipsos(0.06, { lamina: 108, pregunta: P_MARCA, base: 365 }),
    "Hugo Boss": ipsos(0.059, { lamina: 108, pregunta: P_MARCA, base: 365 }),
    Lancome: ipsos(0.05, { lamina: 108, pregunta: P_MARCA, base: 365 }),
    "Tommy Hilfiger": ipsos(0.046, { lamina: 108, pregunta: P_MARCA, base: 365 }),
    "Jean Paul": ipsos(0.034, { lamina: 108, pregunta: P_MARCA, base: 365 }),
    "La Polo": ipsos(0.03, { lamina: 108, pregunta: P_MARCA, base: 365 }),
    212: ipsos(0.03, { lamina: 108, pregunta: P_MARCA, base: 365 }),
  },
  prioridades: {
    Aroma: ipsos(0.737, { lamina: 108, pregunta: P_PRIORIDAD, base: 365 }),
    Duración: ipsos(0.131, { lamina: 108, pregunta: P_PRIORIDAD, base: 365 }),
    Precio: ipsos(0.082, { lamina: 108, pregunta: P_PRIORIDAD, base: 365 }),
    Exclusividad: ipsos(0.029, { lamina: 108, pregunta: P_PRIORIDAD, base: 365 }),
    Calidad: ipsos(0.012, { lamina: 108, pregunta: P_PRIORIDAD, base: 365 }),
    "Siempre la misma colonia": ipsos(0.01, { lamina: 108, pregunta: P_PRIORIDAD, base: 365 }),
  },
  // factor = compras por año (supuesto comercial derivado de la frecuencia Ipsos)
  frecuenciaCompra: {
    mensual: {
      pct: ipsos(0.061, { lamina: 108, pregunta: P_FRECUENCIA, base: 365 }),
      factor: supuesto(12, { nota: "compras por año" }),
      label: "Mensual",
    },
    bimestral: {
      pct: ipsos(0.1, { lamina: 108, pregunta: P_FRECUENCIA, base: 365 }),
      factor: supuesto(6, { nota: "compras por año" }),
      label: "Cada 2 meses",
    },
    trimestral: {
      pct: ipsos(0.18, { lamina: 108, pregunta: P_FRECUENCIA, base: 365 }),
      factor: supuesto(4, { nota: "compras por año" }),
      label: "Cada 3 meses",
    },
    cuatrimestral: {
      pct: ipsos(0.086, { lamina: 108, pregunta: P_FRECUENCIA, base: 365 }),
      factor: supuesto(3, { nota: "compras por año" }),
      label: "Cada 4 meses",
    },
    semestral: {
      pct: ipsos(0.174, { lamina: 108, pregunta: P_FRECUENCIA, base: 365 }),
      factor: supuesto(2, { nota: "compras por año" }),
      label: "Cada 6 meses",
    },
    anual: {
      pct: ipsos(0.353, { lamina: 108, pregunta: P_FRECUENCIA, base: 365 }),
      factor: supuesto(1, { nota: "compras por año" }),
      label: "1 vez al año",
    },
    cualquierFecha: {
      pct: ipsos(0.011, { lamina: 108, pregunta: P_FRECUENCIA, base: 365 }),
      factor: supuesto(2, {
        nota: "compras por año asumidas para 'cualquier fecha', frecuencia atípica sin patrón Ipsos",
      }),
      label: "Cualquier fecha",
    },
    noCompra: {
      pct: ipsos(0.036, { lamina: 108, pregunta: P_FRECUENCIA, base: 365 }),
      factor: supuesto(0, { nota: "no compra" }),
      label: "No compra",
    },
  },
  cantidadPerfumes: {
    1: ipsos(0.399, { lamina: 108, pregunta: P_CANTIDAD, base: 365 }),
    2: ipsos(0.184, { lamina: 108, pregunta: P_CANTIDAD, base: 365 }),
    3: ipsos(0.181, { lamina: 108, pregunta: P_CANTIDAD, base: 365 }),
    4: ipsos(0.06, { lamina: 108, pregunta: P_CANTIDAD, base: 365 }),
    5: ipsos(0.097, { lamina: 108, pregunta: P_CANTIDAD, base: 365 }),
    "6+": ipsos(0.079, { lamina: 108, pregunta: P_CANTIDAD, base: 365, nota: "suma de 6 (2,7%) y 7+ (5,2%)" }),
  },
};

// Opciones de ticket promedio (CLP) — supuesto comercial
export const TICKETS_PERFUME = [
  supuesto(50000, { nota: "ticket promedio de compra" }),
  supuesto(75000, { nota: "ticket promedio de compra" }),
  supuesto(100000, { nota: "ticket promedio de compra" }),
  supuesto(125000, { nota: "ticket promedio de compra" }),
];

// Escenarios de captación — supuesto comercial
export const ESCENARIOS_CAPTACION = [
  supuesto(2, { nota: "escenario de captación de mercado" }),
  supuesto(4, { nota: "escenario de captación de mercado" }),
  supuesto(6, { nota: "escenario de captación de mercado" }),
  supuesto(8, { nota: "escenario de captación de mercado" }),
  supuesto(10, { nota: "escenario de captación de mercado" }),
];

// Referencia fija del simulador (3 meses) — supuesto comercial
export const INVERSION_REFERENCIA_3M = supuesto(6000000, { nota: "inversión de referencia, campaña de 3 meses" });
